import request from '../utils/request'
import global from '../config/global'

function setup_database( data = {}) {
  return request({
    url: global.endpoint.CONFIGURATION_DATABASE,
    method: 'put',
    data
  })
}

export default {
  setup_database,
}
